export default "__VITE_ASSET__Bx4NT3bx__"